















import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store';
import OtDocumentLayout from '@/components/documents/document-layout/ot-document-layout.vue';
import { ROUTE_GLOBAL_DOCUMENT, ROUTE_GLOBAL_DOCUMENT_ASSOCIATIONS } from './documents-routes';

@Component({
  components: {
    OtDocumentLayout,
  },
})
export default class OtGlobalDocumentLayout extends Vue {
  private get detailsRouteName() {
    return ROUTE_GLOBAL_DOCUMENT;
  }
  private get associationsRouteName() {
    return ROUTE_GLOBAL_DOCUMENT_ASSOCIATIONS;
  }
}
